// modulesList.js (ή μέσα στο ίδιο component)
export const getModulesList = (t) => [
  {
    title: t("tool.modules.dataQuality.title"),
    description: t("tool.modules.dataQuality.description"),
  },
  {
    title: t("tool.modules.trajectoriesAnalytics.title"),
    description: t("tool.modules.trajectoriesAnalytics.description"),
  },
  {
    title: t("tool.modules.externalData.title"),
    description: t("tool.modules.externalData.description"),
  },
  {
    title: t("tool.modules.eventInputForms.title"),
    description: t("tool.modules.eventInputForms.description"),
  },
  {
    title: t("tool.modules.publicTransportKpis.title"),
    description: t("tool.modules.publicTransportKpis.description"),
  },
  {
    title: t("tool.modules.bottlenecks.title"),
    description: t("tool.modules.bottlenecks.description"),
  },
  {
    title: t("tool.modules.offlineSimulation.title"),
    description: t("tool.modules.offlineSimulation.description"),
  },
  {
    title: t("tool.modules.onlineSimulation.title"),
    description: t("tool.modules.onlineSimulation.description"),
  },
  {
    title: t("tool.modules.trafficPrediction.title"),
    description: t("tool.modules.trafficPrediction.description"),
  },
  {
    title: t("tool.modules.disruptionPrediction.title"),
    description: t("tool.modules.disruptionPrediction.description"),
  },
  {
    title: t("tool.modules.roadworksPlanning.title"),
    description: t("tool.modules.roadworksPlanning.description"),
  },
  {
    title: t("tool.modules.citsSignalControl.title"),
    description: t("tool.modules.citsSignalControl.description"),
  },
  {
    title: t("tool.modules.autoInterventions.title"),
    description: t("tool.modules.autoInterventions.description"),
  },
  {
    title: t("tool.modules.socialRouting.title"),
    description: t("tool.modules.socialRouting.description"),
  },
  {
    title: t("tool.modules.kpisCalculation.title"),
    description: t("tool.modules.kpisCalculation.description"),
  },
  {
    title: t("tool.modules.tmpsExchange.title"),
    description: t("tool.modules.tmpsExchange.description"),
  },
];
